var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "camera-power-on",
  transform: "translate(3099 3758)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31620",
  "data-name": "Group 31620",
  transform: "translate(-3099 -3758)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_378030ac88ef30f612d73644ecfa1025",
  "data-name": "378030ac88ef30f612d73644ecfa1025",
  d: "M9.783,10.261A2.253,2.253,0,1,0,7.467,8.009,2.285,2.285,0,0,0,9.783,10.261Zm0-3a.751.751,0,1,1-.772.751A.762.762,0,0,1,9.783,7.259Zm7.4,6.876a7.472,7.472,0,0,0-2-3.205A5.893,5.893,0,0,0,13.724,3.4a6.311,6.311,0,0,0-7.881,0A5.893,5.893,0,0,0,4.38,10.929a7.4,7.4,0,0,0-2.007,3.205,2.2,2.2,0,0,0,.363,1.974,2.339,2.339,0,0,0,1.876.908H14.955a2.339,2.339,0,0,0,1.868-.908A2.2,2.2,0,0,0,17.186,14.135ZM9.783,3.506a4.569,4.569,0,0,1,4.632,4.5,4.569,4.569,0,0,1-4.632,4.5,4.569,4.569,0,0,1-4.632-4.5,4.569,4.569,0,0,1,4.632-4.5Zm5.805,11.7a.779.779,0,0,1-.633.308H4.611a.779.779,0,0,1-.633-.308.734.734,0,0,1-.116-.653,5.858,5.858,0,0,1,1.451-2.417,6.3,6.3,0,0,0,8.939,0A5.858,5.858,0,0,1,15.7,14.555.734.734,0,0,1,15.588,15.208Z",
  transform: "translate(-2.279 -2.017)"
})))));

export default __webpack_public_path__ + "static/media/camera-power-on.dead0521.svg";
export { SvgComponent as ReactComponent };